<template>
	<div>
		<div class="content">
			<div class="first_title">Where did you hear about us?</div>
			<input type="text" v-model="origin" placeholder="">
			<!-- <div class="permission">
				<div class="title">是否愿意接收我们的promotion information， newsletter etc？</div>
				<div class="select_list flex align-center" @click="is_receive = 1">
					<div class="item flex align-center">
						<img class="select" src="../../assets/images/icon/select_active.png" v-if="is_receive == 1" alt="">
						<div class="select" v-else></div>
						<div>Yes please</div>
					</div>
					<div class="item flex align-center" @click="is_receive = 0">
						<img class="select" src="../../assets/images/icon/select_active.png" v-if="is_receive == 0" alt="">
						<div class="select" v-else></div>
						<div>No please</div>
					</div>
				</div>
			</div> -->
			<div class="next_btn" @click='toNext'>Complete</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				origin:'',
				is_receive:0
			}
		},
		methods:{
			toNext(){
				var params = {
					is_receive:this.is_receive,
					origin:this.origin
				}
				this.$api.post('user/createOrigin',params,res=>{
					if(res.code == 1){
						this.$message('Successful')
						this.$emit('toNext',{type:3})
					}else{
						this.$message(res.msg)
					}
				})
				
			}
		}
	}
</script>

<style scoped lang="scss">
	.content{
		width: 800px;
		margin: 0 auto 60px;
		.first_title{
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #282E30;
		}
		input{
			width: 100%;
			height: 80px;
			background: #F7F2EB;
			border: 1px solid #282E30;
			border-radius: 10px;
			margin-top: 30px;
			padding-left: 30px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #999999;
			line-height: 80px;
		}
		.permission{
			width: 800px;
			margin: 0 auto;
			margin-top: 40px;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
			}
			.select_list{
				margin-top: 20px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				.item{
					margin-right: 30px;
					cursor: pointer;
				}
				.select{
					width: 16px;
					height: 16px;
					border: 1px solid #282E30;
					border-radius: 50%;
					margin-right: 10px;
				}
			}
		}
		.next_btn{
			width: 182px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			line-height: 57px;
			text-align: center;
			margin: 58px auto;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
</style>